import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import tradeApi from "api/tradeApi";
import { formatQueryParams } from "helpers/format";

export const getDashboard = createAsyncThunk(
  "dashboard",
  async (params: any = {}) => {
    try {
      const response = await tradeApi.dashboard(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);
